import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import Button from "components/CustomButtons/Button.js";
import Tooltip from "@mui/material/Tooltip";
import Add from "@mui/icons-material/Add";
import TribalismProcess from "pages-sections/services/seo-services/TribalismProcess.js";

import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

import styles from "../ServicesSections.module.scss";
export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem
          xs={12}
          sm={10}
          md={10}
          lg={8}
          className={classes.section}
          alignItems="center"
          style={{ paddingLeft: "130px", paddingBottom: "80px" }}
        >
          <h3 className={classes.title}>Our guarantee to you:</h3>
          <ul>
            <li>No Lock in Contracts </li>
            <li>We treat your campaigns as if they were my own </li>
            <li>
              Full transparency over the costs, you have admin access to the
              account
            </li>
            <li>100% Customer Satisfaction, Real Results</li>
            <li>
              All keywords are carefully selected. We don't want you to have
              unwanted traffic that you pay for
            </li>
          </ul>
        </GridItem>
      </GridContainer>
    </div>
  );
}
